import { StateKeys, TemplateSTATEObject } from "@services/storage/storeTemplate";
import { store } from "../../store";
import * as reducer from "./slice";

export const dispatchHydrateState = (state: TemplateSTATEObject) => {
  store.dispatch(
    reducer.hydrate({
      value: state,
    })
  );
};

export const dispatchSetState = (name: StateKeys, value: any) => {
  store.dispatch(
    reducer.set({
      name,
      value,
    })
  );
};

export const dispatchImportState = (value: any) => {
  store.dispatch(
    reducer.importing({
      value,
    })
  );
};

export const dispatchResetState = (value?: any) => {
  store.dispatch(
    reducer.reset({
      value,
    })
  );
};

export const dispatchSetMultipleState = (value: Partial<TemplateSTATEObject>) => {
  store.dispatch(
    reducer.setMultiple({
      value,
    })
  );
};

export const dispatchResetSquareState = () => {
  store.dispatch(reducer.resetSquareState());
};

export const dispatchSaveState = () => {
  store.dispatch(reducer.save());
};

export default reducer;
